export default __webpack_public_path__ + "static/media/lato-blackitalic.390681f7.ttf";